import { render, staticRenderFns } from "./page-job-industry.vue?vue&type=template&id=fbc6c8f4"
import script from "./page-job-industry.vue?vue&type=script&lang=js"
export * from "./page-job-industry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports